import {
  mainRequests
} from './custom'
export default {
  login (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/login', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getDeliveryByDriver (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/deliveyByDriver', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCountDataByDriver () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth('/countDataByDriver')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAllWorkers () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAuth('/workersList')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateDelivery (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postAuth('/delivery', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
